export default "__VITE_ASSET__BMEX5PNP__"